// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 341) return "static/chunks/341-6278f1dca28b9e27.js";
	if (chunkId === 637) return "static/chunks/637-99f8e0aef759210d.js";
	if (chunkId === 241) return "static/chunks/241-d3f91aed17762d75.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"124":"f7d65f09f0404156","582":"6420d92000eedb6a","961":"7cda99ebe6eccffa"}[chunkId] + ".js";
};